<template>
  <div class="list-message">
    <div class="box-messages" v-for="message in messages" :key="message.id">
      <el-row class="mt-20" v-if="message.from == $contactFrom.admin">
        <div class="el-col">
          <el-avatar :size="100" :src="'../../images/アイコン.png'"/>
        </div>
        <div class="el-col sender">
          <span>{{ $t('kokoroduke_admin') }}</span><br>
          <span>{{ $dayjs(message.created_at).format('YY/MM/DD HH:mm') }}</span>
        </div>
        <div class="message-from">
          <p v-html="message.message" class="break-word whitespace-pre-line"></p>
        </div>
      </el-row>
      <el-row class="mt-20 justify-content-end" v-if="message.from == $contactFrom.contacter">
        <div class="message-reply">
          <p v-html="message.message" class="break-word whitespace-pre-line"></p>
        </div>
        <div class="el-col sender">
          <span>{{ contact.contacter_name }}様</span><br>
          <span>{{ $dayjs(message.created_at).format('YY/MM/DD HH:mm') }}</span>
        </div>
        <div class="el-col">
          <el-avatar :size="100" :src="contact.contacter_avatar_url"/>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      messages: { type: Object, required: true, default: {} },
      contact: { type: Object, required: true, default: {} },
    },

    data() {
      return {
      }
    },
  }
</script>

<style lang="scss" scoped>
  .box-contact-detail {
    .list-message{
      height: 500px;
      overflow-y: auto;
      .box-messages {
        .sender {
          padding: 25px;
          font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          color: #000000;
        }
        .message-from  {
          position: relative;
          margin-left: 20px;
          margin-bottom: 10px;
          padding: 10px;
          background-color: #FFFFFF;
          max-width: 700px;
          height: auto;
          text-align: left;
          font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          color: #000000;
          border: 1px solid #CBBFAD;
          border-radius: 20px;
          ::before {
            content: '';
            position: absolute;
            visibility: visible;
            top: 25px;
            left: -40px;
            border-left: 40px solid transparent;
            border-top: 50px solid #CBBFAD;
          }
          ::after {
            content: '';
            position: absolute;
            visibility: visible;
            top: 26px;
            left: -39px;
            border-left: 40px solid transparent;
            border-top: 49px solid white;
            clear: both;
          }
        }
        .message-reply {
          position: relative;
          margin-right: 30px;
          margin-bottom: 10px;
          padding: 10px;
          background-color: #F7F3ED;
          max-width: 700px;
          height: auto;
          text-align: left;
          font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          color: #000000;
          border: 1px solid #F7F3ED;
          border-radius: 20px;
          ::before {
            content: '';
            position: absolute;
            visibility: visible;
            top: 25px;
            right: -40px;
            border-right: 40px solid transparent;
            border-top: 50px solid #F7F3ED;
          }
          ::after {
            content: '';
            position: absolute;
            visibility: visible;
            top: 26px;
            right: -39px;
            border-right: 40px solid transparent;
            border-top: 49px solid #F7F3ED;
            clear: both;
          }
        }
        .el-avatar {
          --el-avatar-bg-color: #E9E5DF;
        }
      }
    }
  }
</style>
